<template>
<div class="container mt-5">
    <div class="row header-wrapper">
        <div class="col-lg-6 align-self-center">
            <div>
              <img src="/images/logos/sweet-spot.svg" alt="Sweet Spot Logo" role="presentation" class="experience-icon">
              <h1 class="experience-title">{{template.title}}</h1>
              <p class="experience-content mobile-padding" data-swiftype-name="body" data-swiftype-type="text">{{template.content}}</p>
            </div>
        </div>
        <div v-if="template.image" class="col-lg-6 mt-5 align-self-center">
          <figcaption>
              <img :src="`https://alabama-travel.s3.amazonaws.com/partners-uploads/ad_campaign/image/${template.image}`" :alt="template.imageCaption" class="experience-image image-fluid"/>
              <figcaption>
                <router-link v-if="template.imageLink" aria-label="" :to="template.imageLink" data-gtcat="hero-loc">{{ template.imageCaption }}</router-link>
              </figcaption>
          </figcaption>
        </div>
    </div>
    </div>
</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({
  data() {
    return {};
  },
})
class CampaignHeader extends Vue {
    @Prop({
      type: [Object],
      required: true,
    })
    template;

    @Prop({
      type: String,
    })
    slug;
}

export default CampaignHeader;
</script>

<style lang="scss" scoped>
.breadcrumb { padding: 0px;}
.mobile-padding {
  padding:0px;
}
figcaption {
  font-family: 'klinicslabmedium';
  font-size: 1.5rem;
  text-align: right;
}
.figcaption a {
  padding: 10px 0 10px 0;
}
.experience-icon {
  margin-bottom: 15px;
  width:125px;
}
.header-wrapper {
  margin-bottom: 164px;
  margin-left:26px;
  margin-right:26px;
}
.experience-image {
  width: 100%;
}
.experience-title {
  line-height: 52px;
  margin-bottom: 40px;
}
.experience-content {
  font-family: 'IdealSans-Book','Avenir', Helvetica, Arial, sans-serif;
  font-size: 1rem;
  margin-bottom: 50px;
@media only screen and (min-width: 812px) {
    //padding: 25px;
}
@media only screen and (min-width: 769px) {
    margin: 0 40px;
}
@media only screen and (min-width: 769px) {
  margin: 20px 110px;
}
}
.experience-breadcrumb {
  display: flex;
  align-items: center;
  justify-content: center;
}

</style>
